import { HTTP_CLIENT } from '@common/clients/http/http.client.interface';
import { container } from 'tsyringe';
import standardRepositoryImpl from './repositories/standard.repository.impl';
import IStandardRepository from './repositories/standard.repository.interface';

// INFRASTRUCTURE
const httpClient = container.resolve(HTTP_CLIENT);

// REPOSITORIES
const standardRepository = container
  .register<IStandardRepository>('StandardRepository', {
    useValue: standardRepositoryImpl(httpClient),
  })
  .resolve<IStandardRepository>('StandardRepository');

export default standardRepository;
